import { StageDetails } from "../../types/tournament";
import {
  deleteAmericanoSchedule,
  deleteGroupSchedule,
  deleteKnockoutSchedule,
  deleteLeagueSchedule,
  deleteMexicanoSchedule,
} from "../../api/tournaments";
import { ConfirmDialog } from "../../ui";
import { isLiveRoundFormat } from "../../utils/methods";

type DeleteScheduleDialogProps = {
  stage: StageDetails;
  isOpen: boolean;
  onClose: (update?: boolean) => void;
};

const DeleteScheduleDialog = (props: DeleteScheduleDialogProps) => {
  // A failed delete throws, so the dialog stays open (the api reports the error); a successful one closes with update.
  const handleDelete = async () => {
    if (props.stage.formatName === "Group") await deleteGroupSchedule(props.stage.id);
    if (props.stage.formatName === "League") await deleteLeagueSchedule(props.stage.id);
    if (props.stage.formatName === "Knockout") await deleteKnockoutSchedule(props.stage.id);
    if (props.stage.formatName === "Americano") await deleteAmericanoSchedule(props.stage.id);
    // Mexicano and Roulette share the api/Mexicano routes.
    if (isLiveRoundFormat(props.stage.formatName)) await deleteMexicanoSchedule(props.stage.id);
  };

  return (
    <ConfirmDialog
      open={props.isOpen}
      onClose={(confirmed) => props.onClose(confirmed ? true : undefined)}
      onConfirm={handleDelete}
      title="Are you sure?"
      message="This action cannot be undone. If you delete this schedule, you will lose all teams & match data in this stage."
      confirmLabel="Delete"
      tone="danger"
    />
  );
};

export default DeleteScheduleDialog;
